module.exports = __webpack_public_path__ + "img/Component Under.6fe15c23.png";